import { useLocation } from 'react-router-dom';
import { LOGIN_URL } from '../lib/auth';
import AuthLayout from '../components/AuthLayout';
import { Button } from '@mes-amis/galette-design-system';

export default function LoginPage() {
  const location = useLocation();

  const loginHref = `${LOGIN_URL}${
    location.pathname !== '/login'
      ? `?return_to=${encodeURIComponent(location.pathname + location.search)}`
      : ''
  }`;

  return (
    <AuthLayout>
      {/* Heading + description */}
      <div className="flex flex-col gap-4">
        <h1 className="font-heading text-[28px] leading-8 text-black">
          Authentication Required
        </h1>
        <p className="text-sm leading-5 text-black">
          You need to be logged in to access Mon Ami GO
        </p>
      </div>

      {/* CTA */}
      <div className="flex flex-col items-start gap-2">
        <Button variant="primary" href={loginHref} size="md">
          Log in with Mon Ami
        </Button>
      </div>
    </AuthLayout>
  );
}
